var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pl-0 pr-0",attrs:{"fluid":""}},[_c('v-card',{staticClass:"pa-5",attrs:{"outlined":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }